import { Paper, Typography } from "@mui/material";
import Layout from "../../components/Layout";
import { useT } from "../../i18n";
import ExterneSystemeDataTable from "../../components/externesysteme/ExterneSystemeDataTable";
import Guard from "../../components/Guard";
import React from "react";
import ErrorAlert from "../../components/ErrorAlert";
import { notPermitted } from "../../errors";

export default function ExterneSystemeListe() {
  const { t } = useT("externesysteme");
  const limit = parseInt(
    localStorage.getItem("externe-systemeLimit") ?? "25",
    10
  );
  return (
    <Layout title={t("header")} showTitleInNav={false}>
      <Guard
        permission={"systemextern:list"}
        fallback={<ErrorAlert error={notPermitted()} />}
      >
        <Paper
          elevation={1}
          sx={{ marginTop: 2, padding: 3, marginLeft: 2, marginRight: 2 }}
        >
          <Typography variant="h5">{t("header")}</Typography>
          <ExterneSystemeDataTable limit={limit} />
        </Paper>
      </Guard>
    </Layout>
  );
}
